import axios from 'axios';
import ReasonsCancellation from '../domain/reasons-cancellation.entity';

export default class ReasonsCancellationService {
  public static getAll(businessUnitId: string): Promise<any[]> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/reasons-cancellation`)
      .then((response: any) => ReasonsCancellation.ofList(response.data));
  }

  public static getById(
    businessUnitId: string,
    reasonCancellationId: string,
  ) : Promise<any> {
    return axios
      .get(`/api/v1/business-units/${businessUnitId}/reasons-cancellation/${reasonCancellationId}`)
      .then((response: any) => ReasonsCancellation.of(response.data));
  }

  public static getByJustificationId(
    businessUnitId: string,
    justificationId: string,
  ) : Promise<any> {
    return axios
      .get(`/api/v1/business-units/${businessUnitId}/reasons-cancellation/justification/${justificationId}`)
      .then((response: any) => response.data);
  }

  public static businessUnitReasonsCancellationRequired(
    businessUnitId: string,
    status: boolean,
  ): Promise<any> {
    return axios
      .put(`/api/v1/business-units/${businessUnitId}/reasons-cancellation-required`, { required: status })
      .then((response: any) => response.data)
      .catch((error: any) => error.response.data);
  }

  public static getBusinessUnitAllowReasonsCancellation(
    businessUnitId: string,
  ): Promise<boolean> {
    return axios
      .get(`/api/v1/business-units/${businessUnitId}/reasons-cancellation-required`)
      .then((response: any) => response.data)
      .catch((error: any) => error.response.data);
  }

  public static createReasonsCancellation(
    businessUnitId: string,
    reasonsCancellations: Object,
  ): Promise<any> {
    return axios
      .post(`/api/v1/business-units/${businessUnitId}/reasons-cancellation`, reasonsCancellations)
      .then((response: any) => response.data)
      .catch((error: any) => error.response.data);
  }

  public static updateReasonsCancellation(
    businessUnitId: string,
    reasonCancellationId: string,
    reasonsCancellations: Object,
  ): Promise<any> {
    return axios.put(
      `/api/v1/business-units/${businessUnitId}/reasons-cancellation/${reasonCancellationId}`,
      reasonsCancellations,
    )
      .then((response: any) => response.data)
      .catch((error: any) => error.response.data);
  }

  public static inactiveReasonsCancellation(
    reasonCancellationId: string,
  ): Promise<void> {
    return axios.put(`/api/v1/reasons-cancellation/inactivate/${reasonCancellationId}`);
  }
}
